// AUTO GENERATED FILE - Changes WILL be lost.
// de-DE - used as 'de' fallback
export const common_fallback = true

export const translations = {
  "betslip.title": "Wettschein",
  "last60.fixture": "{visitor} {'@'} {home}",
  "last60.fixtureResult": "{visitor} ({visitorScore}) {'@'} ({homeScore}) {home}",
  "sb.fixture": "{home} VS. {away}",
  "sb.fixtureResult": "{home} {homeScore} - {awayScore} {away}",
  "betslip.bet": "Wette platzieren",
  "betslip.clear": "Alle löschen",
  "betslip.clearResult": "Löschen",
  "betslip.noSelections": "Auswahlen hinzufügen, um mit dem Wetten zu beginnen",
  "betslip.notLoggedIn": "Anmelden, um mit dem Wetten zu beginnen",
  "betslip.refresh": "Aktualisieren",
  "betslip.totalStake": "Gesamteinsatz",
  "betslip.noHistoryData": "Keine Wettinformationen verfügbar",
  "betslip.openBets": "Offenen Wetten",
  "betslip.betHistory": "Wettverlauf",
  "betslip.betHistoryWon": "Gewonnen",
  "betslip.betHistoryLost": "Verloren",
  "loading.loading": "Wird geladen",
  "loading.account": "Konto wird geladen",
  "loading.league": "Liga wird geladen",
  "loading.gameweeks": "Spielwochen werden geladen",
  "loading.markets": "Märkte werden geladen",
  "loading.bethistory": "Wettverlauf wird geladen",
  "login.loginRequired": "Anmeldung nötig",
  "login.loginToBet": "Bitte anmelden, um mit dem Wetten zu beginnen",
  "navigation.back": "Zurück",
  "navigation.close": "Schließen",
  "video.liveStreamAvailable": "Live-Stream verfügbar",
  "video.logInToWatch": "Zum Anschauen bitte anmelden",
  "error.error": "Fehler",
  "error.404": "Seite nicht gefunden",
  "error.gameLaunchFailed": "Spiel konnte nicht geladen werden",
  "error.unknownErrorCode": "Unbekannter Fehler: {code}",
  "error.minUnitStakeLimitExceeded": "Mindesteinsatz beträgt {limit}",
  "error.maxUnitStakeLimitExceeded": "Maximaleinsatz beträgt {limit}",
  "error.minTotalStakeLimitExceeded": "Minimaler Gesamteinsatz beträgt {limit}",
  "error.maxTotalStakeLimitExceeded": "Maximaler Gesamteinsatz beträgt {limit}",
  "error.notPlaced": "Nicht platziert",
  "error.wagerDisallowed": "Einsatz nicht erlaubt",
  "error.errorEventIsOff": "Event hat begonnen",
  "multiplebet.Singles": "Einzelwetten",
  "multiplebet.Doubles": "Doppelwetten",
  "multiplebet.Trebles": "Dreifachwetten",
  "multiplebet.Accumulator": "Akkumulator",
  "multiplebet.Perm 4-Folds": "4-fache Kombinationswette",
  "multiplebet.Perm 5-Folds": "5-fache Kombinationswette",
  "multiplebet.Perm 6-Folds": "6-fache Kombinationswette",
  "multiplebet.Perm 7-Folds": "7-fache Kombinationswette",
  "multiplebet.Perm 8-Folds": "8-fache Kombinationswette",
  "multiplebet.Perm 9-Folds": "9-fache Kombinationswette",
  "sb-english.team.ARS": "Arsenal",
  "sb-english.team.AST": "Aston V.",
  "sb-english.team.BHA": "Brighton",
  "sb-english.team.BOU": "Bournemouth",
  "sb-english.team.BUR": "Burnley",
  "sb-english.team.CHE": "Chelsea",
  "sb-english.team.CRY": "C. Palace",
  "sb-english.team.EVE": "Everton",
  "sb-english.team.LEI": "Leicester",
  "sb-english.team.LIV": "Liverpool",
  "sb-english.team.MNC": "Manchester C.",
  "sb-english.team.MNU": "Manchester U.",
  "sb-english.team.NEW": "Newcastle",
  "sb-english.team.SOU": "Southampton",
  "sb-english.team.TOT": "Tottenham",
  "sb-english.team.WAT": "Watford",
  "sb-english.team.WHU": "West Ham",
  "sb-english.team.WOL": "Wolves",
  "sb-english.team.NOR": "Norwich",
  "sb-english.team.SHU": "Sheffield U.",
  "sb-english.team.LEE": "Leeds",
  "sb-english.team.FUL": "Fulham",
  "sb-english.team.WBA": "West Brom",
  "sb-greek.team.AEK": "AEK ATHENS",
  "sb-greek.team.APS": "APOLLON SMYRNIS",
  "sb-greek.team.ARI": "ARIS THESSALONIKI",
  "sb-greek.team.AST": "ASTERAS TRIPOLI",
  "sb-greek.team.ATR": "ATROMITOS",
  "sb-greek.team.GIA": "PAS GIANNINA",
  "sb-greek.team.LEV": "LEVADIAKOS",
  "sb-greek.team.OFI": "OFI",
  "sb-greek.team.OLM": "OLYMPIAKOS",
  "sb-greek.team.PTK": "PANATHINAIKOS",
  "sb-greek.team.PNS": "PANIONIOS",
  "sb-greek.team.PAO": "PAOK SALONIKA",
  "sb-greek.team.PLT": "PLATANIAS",
  "sb-greek.team.XAN": "XANTHI",
  "sb-italian.team.MIL": "Milan",
  "sb-italian.team.ATA": "Atalanta",
  "sb-italian.team.BOL": "Bologna",
  "sb-italian.team.BRE": "Brescia",
  "sb-italian.team.CAG": "Cagliari",
  "sb-italian.team.CHI": "Chievo",
  "sb-italian.team.FIO": "Fiorentina",
  "sb-italian.team.GEN": "Genoa",
  "sb-italian.team.INT": "Inter",
  "sb-italian.team.JUV": "Juventus",
  "sb-italian.team.LAZ": "Lazio",
  "sb-italian.team.NAP": "Napoli",
  "sb-italian.team.ROM": "Roma",
  "sb-italian.team.SAM": "Sampdoria",
  "sb-italian.team.UDI": "Udinese",
  "sb-italian.team.VER": "Verona",
  "nomorebets": "Keine weiteren Wetten",
  "playtime": "Spielzeit",
  "gameId": "Spiel-ID",
  "noGames": "Es sind keine Spiele verfügbar. Schauen Sie bald zurück.",
  "Home": "Startseite",
  "Away": "Weg",
  "Visitor": "Besucher",
  "soccerbet.gameWeek": "SPIELWOCHE",
  "soccerbet.noGameWeeks": "Es sind keine Spielwochen verfügbar. Schauen Sie später noch einmal vorbei.",
  "soccerbet.league": "Liga-Tabelle",
  "soccerbet.table.name": "Namen",
  "soccerbet.table.won": "S",
  "soccerbet.table.drawn": "U",
  "soccerbet.table.lost": "N",
  "soccerbet.table.points": "PKT",
  "market.abbr.Both Teams To Score": "BTT",
  "market.Both Teams To Score": "Beide Teams treffen",
  "market.Over / Under": "Unter/Über",
  "market.Double Chance": "Doppelte Chance",
  "market.Match Result": "Spielergebnis",
  "market.Exact Goals": "Genaue Anzahl der Tore",
  "market.Correct Score": "Genaues Ergebnis",
  "market.Match Result Both Score": "Spielergebnis, Beide Teams treffen",
  "market.Result Und/Over 1.5 Total Goals": "Ergebnis, Über/Unter 1,5 Tore",
  "market.Result Und/Over 2.5 Total Goals": "Ergebnis, Über/Unter 2,5 Tore",
  "market.Under Over 1.5 Total Goals": "Über/Unter 1,5 Tore",
  "market.Under Over 2.5 Total Goals": "Über/Unter 2,5 Tore",
  "market.Under Over 3.5 Total Goals": "Über/Unter 3,5 Tore",
  "market.Under Over 4.5 Total Goals": "Über/Unter 4,5 Tore",
  "market.Total Goals 1 To 2": "Gesamttore 1 bis 2",
  "market.Total Goals 1 To 3": "Gesamttore 1 bis 3",
  "market.Total Goals 1 To 4": "Gesamttore 1 bis 4",
  "market.Total Goals 2 To 3": "Gesamttore 2 bis 3",
  "market.Total Goals 2 To 4": "Gesamttore 2 bis 4",
  "market.Under Over 1.5 Home Goals": "Über/Unter 1,5 Tore Heimmannschaft",
  "market.Under Over 1.5 Away Goals": "Über/Unter 1,5 Tore Auswärtsmannschaft",
  "market.Home Team Exact Goals": "Genaue Anzahl Tore Heimmannschaft",
  "market.Away Team Exact Goals": "Genaue Anzahl Tore Auswärtsmannschaft",
  "selection.Yes": "Ja",
  "selection.No": "Nein",
  "selection.1+G": "1+T",
  "selection.1+Ng": "1+KT",
  "selection.X+G": "X+T",
  "selection.X+Ng": "X+KT",
  "selection.2+G": "2+T",
  "selection.2+Ng": "2+KT",
  "selection.U": "U",
  "selection.O": "Ü",
  "selection.1+O": "1+O",
  "selection.X+O": "X+O",
  "selection.2+O": "2+O",
  "selection.1+U": "1+U",
  "selection.X+U": "X+U",
  "selection.2+U": "2+U",
  "selection.TID_HOME_WIN": "1",
  "selection.TID_AWAY_WIN": "2",
  "selection.TID_DRAW": "X",
  "selection.TID_HOME_WIN_OR_DRAW": "1x",
  "selection.TID_DRAW_OR_AWAY_WIN": "x2",
  "selection.TID_HOME_OR_AWAY_WIN": "12",
  "selection.Over": "Über",
  "selection.Under": "Unter",
  "sb-english.team.abbr.ARS": "ARS",
  "sb-english.team.abbr.AST": "AST",
  "sb-english.team.abbr.BHA": "BHA",
  "sb-english.team.abbr.BOU": "BOU",
  "sb-english.team.abbr.BUR": "BUR",
  "sb-english.team.abbr.CHE": "CHE",
  "sb-english.team.abbr.CRY": "CRY",
  "sb-english.team.abbr.EVE": "EVE",
  "sb-english.team.abbr.LEI": "LEI",
  "sb-english.team.abbr.LIV": "LIV",
  "sb-english.team.abbr.MNC": "MNC",
  "sb-english.team.abbr.MNU": "MNU",
  "sb-english.team.abbr.NEW": "NEW",
  "sb-english.team.abbr.SOU": "SOU",
  "sb-english.team.abbr.TOT": "TOT",
  "sb-english.team.abbr.WAT": "WAT",
  "sb-english.team.abbr.WHU": "WHU",
  "sb-english.team.abbr.WOL": "WOL",
  "sb-english.team.abbr.NOR": "NOR",
  "sb-english.team.abbr.SHU": "SHU",
  "sb-english.team.abbr.LEE": "LEE",
  "sb-english.team.abbr.FUL": "FUL",
  "sb-english.team.abbr.WBA": "WBA",
  "sb-italian.team.abbr.MIL": "MIL",
  "sb-italian.team.abbr.ATA": "ATA",
  "sb-italian.team.abbr.BOL": "BOL",
  "sb-italian.team.abbr.BRE": "BRE",
  "sb-italian.team.abbr.CAG": "CAG",
  "sb-italian.team.abbr.CHI": "CHI",
  "sb-italian.team.abbr.FIO": "FIO",
  "sb-italian.team.abbr.GEN": "GEN",
  "sb-italian.team.abbr.INT": "INT",
  "sb-italian.team.abbr.JUV": "JUV",
  "sb-italian.team.abbr.LAZ": "LAZ",
  "sb-italian.team.abbr.NAP": "NAP",
  "sb-italian.team.abbr.ROM": "ROM",
  "sb-italian.team.abbr.SAM": "SAM",
  "sb-italian.team.abbr.UDI": "UDI",
  "sb-italian.team.abbr.VER": "VER",
  "sb-greek.team.abbr.AEK": "AEK",
  "sb-greek.team.abbr.APS": "APS",
  "sb-greek.team.abbr.ARI": "ARI",
  "sb-greek.team.abbr.AST": "AST",
  "sb-greek.team.abbr.ATR": "ATR",
  "sb-greek.team.abbr.GIA": "GIA",
  "sb-greek.team.abbr.LEV": "LEV",
  "sb-greek.team.abbr.OFI": "OFI",
  "sb-greek.team.abbr.OLM": "OLM",
  "sb-greek.team.abbr.PTK": "PTK",
  "sb-greek.team.abbr.PNS": "PNS",
  "sb-greek.team.abbr.PAO": "PAO",
  "sb-greek.team.abbr.PLT": "PLT",
  "sb-greek.team.abbr.XAN": "XAN",
  "market.Overall Winner": "Gesamtsieger",
  "market.Last60 Winner": "Die letzten 60 Gewinner",
  "market.Both Teams Over 2.5 Last60": "Beide Teams über 2.5 Letzte 60",
  "market.Both Teams Over 3.5 Last60": "Beide Teams über 3.5 Letzte 60",
  "market.First Team To Score In Last60": "Erstes Team, das in den letzten 60 Punkten punktete",
  "market.Last60 Winner And Winning Margin": "Die letzten 60 Gewinner und Gewinnspanne",
  "market.First To Score 4 Points Last60": "Erster, um 4 Punkte zu erzielen Letzte 60",
  "market.Home Under/Over 4.5 Last60": "{home} über/unter 4.5 Letzte 60",
  "market.Visitor Under/Over 4.5 Last60": "{visitor} über/unter 4.5 Letzte 60",
  "market.Home Under/Over 5.5 Last60": "{home} über/unter 5.5 Letzte 60",
  "market.Visitor Under/Over 5.5 Last60": "{visitor} über/unter 5.5 Letzte 60",
  "market.Last60 Winner And O/U 11.5": "Letzte 60 Sieger und O/U 11.5",
  "market.Last60 Points Difference": "Letzte 60 Punkte Differenz",
  "market.Total 3-Pointers Last60": "Insgesamt 3-Zeiger Letzte 60",
  "selection.Home & 1-3": "{home} & 1-3",
  "selection.Home & 4-6": "{home} & 4-6",
  "selection.Home & 7-9": "{home} & 7-9",
  "selection.Home & 10-12": "{home} &10-12",
  "selection.Home & 13+": "{home} & 13+",
  "selection.Visitor & 1-3": "{visitor} & 1-3",
  "selection.Visitor & 4-6": "{visitor} & 4-6",
  "selection.Visitor & 7-9": "{visitor} & 7-9",
  "selection.Visitor & 10-12": "{visitor} & 10-12",
  "selection.Visitor & 13+": "{visitor} & 13+",
  "selection.Home & Over": "{home} & Über",
  "selection.Home & Under": "{home} & Unter",
  "selection.Visitor & Over": "{visitor} & Über",
  "selection.Visitor & Under": "{visitor} & Unter",
  "selection.Home": "{home}",
  "selection.Visitor": "{visitor}"
}
